var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTextura(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 320 199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7 {\n        stroke-width: 0px;\n      }\n\n      .cls-8 {\n        mix-blend-mode: overlay;\n        opacity: .5;\n      }\n\n      .cls-9 {\n        mask: url(#mask);\n      }\n\n      .cls-2 {\n        fill: url(#Degradado_sin_nombre_3786);\n      }\n\n      .cls-10 {\n        isolation: isolate;\n      }\n\n      .cls-3 {\n        fill: gray;\n      }\n\n      .cls-4 {\n        fill: #dadada;\n      }\n\n      .cls-5 {\n        fill: #bcbcbc;\n      }\n\n      .cls-6 {\n        fill: #9d9d9d;\n      }\n\n      .cls-7 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_3786",
    "data-name": "Degradado sin nombre 3786",
    x1: 156.97,
    y1: -10.27,
    x2: 162.2,
    y2: 177.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: -48.16,
    y: -21.25,
    width: 446.32,
    height: 233.51,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m312.71-16.29H7C-1.36-16.29-8.14-9.2-8.14-.45v187.99c0,8.75,6.78,15.84,15.14,15.84h305.71c8.36,0,15.14-7.09,15.14-15.84V-.45c0-8.75-6.78-15.84-15.14-15.84Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "63.44 2.15 52.28 -9.52 63.44 -21.19 63.44 2.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "41.12 -21.19 52.28 -9.52 41.12 2.15 41.12 -21.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "63.44 2.15 41.12 2.15 52.28 -9.52 63.44 2.15"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "-3.52 -21.19 7.64 -9.52 -3.52 2.15 -3.52 -21.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "18.8 2.15 7.64 -9.52 18.8 -21.19 18.8 2.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "18.8 2.15 -3.52 2.15 7.64 -9.52 18.8 2.15"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "130.39 2.15 119.23 -9.52 130.39 -21.19 130.39 2.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "108.07 -21.19 119.23 -9.52 108.07 2.15 108.07 -21.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "130.39 2.15 108.07 2.15 119.23 -9.52 130.39 2.15"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "152.71 2.15 141.55 -9.52 152.71 -21.19 152.71 2.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "130.39 -21.19 141.55 -9.52 130.39 2.15 130.39 -21.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "152.71 2.15 130.39 2.15 141.55 -9.52 152.71 2.15"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "175.03 2.15 163.87 -9.52 175.03 -21.19 175.03 2.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "152.71 -21.19 163.87 -9.52 152.71 2.15 152.71 -21.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "175.03 2.15 152.71 2.15 163.87 -9.52 175.03 2.15"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "108.07 2.15 96.91 -9.52 108.07 -21.19 108.07 2.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "85.75 -21.19 96.91 -9.52 85.75 2.15 85.75 -21.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "108.07 2.15 85.75 2.15 96.91 -9.52 108.07 2.15"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "85.75 2.15 74.59 -9.52 85.75 -21.19 85.75 2.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "63.44 -21.19 74.59 -9.52 63.44 2.15 63.44 -21.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "85.75 2.15 63.44 2.15 74.59 -9.52 85.75 2.15"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "18.8 -21.19 29.96 -9.52 18.8 2.15 18.8 -21.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "41.12 2.15 29.96 -9.52 41.12 -21.19 41.12 2.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "41.12 2.15 18.8 2.15 29.96 -9.52 41.12 2.15"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "175.03 25.48 163.87 13.82 175.03 2.15 175.03 25.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "152.71 2.15 163.87 13.82 152.71 25.48 152.71 2.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "175.03 25.48 152.71 25.48 163.87 13.82 175.03 25.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "152.71 2.15 175.03 2.15 163.87 13.82 152.71 2.15"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "152.71 25.48 141.55 13.82 152.71 2.15 152.71 25.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "130.39 2.15 141.55 13.82 130.39 25.48 130.39 2.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "152.71 25.48 130.39 25.48 141.55 13.82 152.71 25.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "130.39 2.15 152.71 2.15 141.55 13.82 130.39 2.15"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "63.44 2.15 74.59 13.82 63.44 25.48 63.44 2.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "85.75 25.48 74.59 13.82 85.75 2.15 85.75 25.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "63.44 2.15 85.75 2.15 74.59 13.82 63.44 2.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "85.75 25.48 63.44 25.48 74.59 13.82 85.75 25.48"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "130.39 25.48 119.23 13.82 130.39 2.15 130.39 25.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "108.07 2.15 119.23 13.82 108.07 25.48 108.07 2.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "130.39 25.48 108.07 25.48 119.23 13.82 130.39 25.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "108.07 2.15 130.39 2.15 119.23 13.82 108.07 2.15"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "-3.52 2.15 7.64 13.82 -3.52 25.48 -3.52 2.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "18.8 25.48 7.64 13.82 18.8 2.15 18.8 25.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "-3.52 2.15 18.8 2.15 7.64 13.82 -3.52 2.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "18.8 25.48 -3.52 25.48 7.64 13.82 18.8 25.48"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "18.8 2.15 29.96 13.82 18.8 25.48 18.8 2.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "41.12 25.48 29.96 13.82 41.12 2.15 41.12 25.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "18.8 2.15 41.12 2.15 29.96 13.82 18.8 2.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "41.12 25.48 18.8 25.48 29.96 13.82 41.12 25.48"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "41.12 2.15 52.28 13.82 41.12 25.48 41.12 2.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "63.44 25.48 52.28 13.82 63.44 2.15 63.44 25.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "41.12 2.15 63.44 2.15 52.28 13.82 41.12 2.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "63.44 25.48 41.12 25.48 52.28 13.82 63.44 25.48"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "108.07 25.48 96.91 13.82 108.07 2.15 108.07 25.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "85.75 2.15 96.91 13.82 85.75 25.48 85.75 2.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "108.07 25.48 85.75 25.48 96.91 13.82 108.07 25.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "85.75 2.15 108.07 2.15 96.91 13.82 85.75 2.15"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "175.03 212.19 163.87 200.52 175.03 188.85 175.03 212.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "152.71 188.85 163.87 200.52 152.71 212.19 152.71 188.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "152.71 188.85 175.03 188.85 163.87 200.52 152.71 188.85"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "152.71 212.19 141.55 200.52 152.71 188.85 152.71 212.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "130.39 188.85 141.55 200.52 130.39 212.19 130.39 188.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "130.39 188.85 152.71 188.85 141.55 200.52 130.39 188.85"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "63.44 188.85 74.59 200.52 63.44 212.19 63.44 188.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "85.75 212.19 74.59 200.52 85.75 188.85 85.75 212.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "63.44 188.85 85.75 188.85 74.59 200.52 63.44 188.85"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "130.39 212.19 119.23 200.52 130.39 188.85 130.39 212.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "108.07 188.85 119.23 200.52 108.07 212.19 108.07 188.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "108.07 188.85 130.39 188.85 119.23 200.52 108.07 188.85"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "-3.52 188.85 7.64 200.52 -3.52 212.19 -3.52 188.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "18.8 212.19 7.64 200.52 18.8 188.85 18.8 212.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "-3.52 188.85 18.8 188.85 7.64 200.52 -3.52 188.85"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "18.8 188.85 29.96 200.52 18.8 212.19 18.8 188.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "41.12 212.19 29.96 200.52 41.12 188.85 41.12 212.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "18.8 188.85 41.12 188.85 29.96 200.52 18.8 188.85"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "41.12 188.85 52.28 200.52 41.12 212.19 41.12 188.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "63.44 212.19 52.28 200.52 63.44 188.85 63.44 212.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "41.12 188.85 63.44 188.85 52.28 200.52 41.12 188.85"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "108.07 212.19 96.91 200.52 108.07 188.85 108.07 212.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "85.75 188.85 96.91 200.52 85.75 212.19 85.75 188.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "85.75 188.85 108.07 188.85 96.91 200.52 85.75 188.85"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "63.44 188.85 52.28 177.18 63.44 165.52 63.44 188.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "41.12 165.52 52.28 177.18 41.12 188.85 41.12 165.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "63.44 188.85 41.12 188.85 52.28 177.18 63.44 188.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "41.12 165.52 63.44 165.52 52.28 177.18 41.12 165.52"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "-3.52 165.52 7.64 177.18 -3.52 188.85 -3.52 165.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "18.8 188.85 7.64 177.18 18.8 165.52 18.8 188.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "-3.52 165.52 18.8 165.52 7.64 177.18 -3.52 165.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "18.8 188.85 -3.52 188.85 7.64 177.18 18.8 188.85"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "130.39 188.85 119.23 177.18 130.39 165.52 130.39 188.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "108.07 165.52 119.23 177.18 108.07 188.85 108.07 165.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "130.39 188.85 108.07 188.85 119.23 177.18 130.39 188.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "108.07 165.52 130.39 165.52 119.23 177.18 108.07 165.52"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "152.71 188.85 141.55 177.18 152.71 165.52 152.71 188.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "130.39 165.52 141.55 177.18 130.39 188.85 130.39 165.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "152.71 188.85 130.39 188.85 141.55 177.18 152.71 188.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "130.39 165.52 152.71 165.52 141.55 177.18 130.39 165.52"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "175.03 188.85 163.87 177.18 175.03 165.52 175.03 188.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "152.71 165.52 163.87 177.18 152.71 188.85 152.71 165.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "175.03 188.85 152.71 188.85 163.87 177.18 175.03 188.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "152.71 165.52 175.03 165.52 163.87 177.18 152.71 165.52"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "108.07 188.85 96.91 177.18 108.07 165.52 108.07 188.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "85.75 165.52 96.91 177.18 85.75 188.85 85.75 165.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "108.07 188.85 85.75 188.85 96.91 177.18 108.07 188.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "85.75 165.52 108.07 165.52 96.91 177.18 85.75 165.52"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "85.75 188.85 74.59 177.18 85.75 165.52 85.75 188.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "63.44 165.52 74.59 177.18 63.44 188.85 63.44 165.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "85.75 188.85 63.44 188.85 74.59 177.18 85.75 188.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "63.44 165.52 85.75 165.52 74.59 177.18 63.44 165.52"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "18.8 165.52 29.96 177.18 18.8 188.85 18.8 165.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "41.12 188.85 29.96 177.18 41.12 165.52 41.12 188.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "18.8 165.52 41.12 165.52 29.96 177.18 18.8 165.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "41.12 188.85 18.8 188.85 29.96 177.18 41.12 188.85"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "175.03 72.16 163.87 60.49 175.03 48.82 175.03 72.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "152.71 48.82 163.87 60.49 152.71 72.16 152.71 48.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "175.03 72.16 152.71 72.16 163.87 60.49 175.03 72.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "152.71 48.82 175.03 48.82 163.87 60.49 152.71 48.82"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "152.71 72.16 141.55 60.49 152.71 48.82 152.71 72.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "130.39 48.82 141.55 60.49 130.39 72.16 130.39 48.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "152.71 72.16 130.39 72.16 141.55 60.49 152.71 72.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "130.39 48.82 152.71 48.82 141.55 60.49 130.39 48.82"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "63.44 48.82 74.59 60.49 63.44 72.16 63.44 48.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "85.75 72.16 74.59 60.49 85.75 48.82 85.75 72.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "63.44 48.82 85.75 48.82 74.59 60.49 63.44 48.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "85.75 72.16 63.44 72.16 74.59 60.49 85.75 72.16"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "130.39 72.16 119.23 60.49 130.39 48.82 130.39 72.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "108.07 48.82 119.23 60.49 108.07 72.16 108.07 48.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "130.39 72.16 108.07 72.16 119.23 60.49 130.39 72.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "108.07 48.82 130.39 48.82 119.23 60.49 108.07 48.82"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "-3.52 48.82 7.64 60.49 -3.52 72.16 -3.52 48.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "18.8 72.16 7.64 60.49 18.8 48.82 18.8 72.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "-3.52 48.82 18.8 48.82 7.64 60.49 -3.52 48.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "18.8 72.16 -3.52 72.16 7.64 60.49 18.8 72.16"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "18.8 48.82 29.96 60.49 18.8 72.16 18.8 48.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "41.12 72.16 29.96 60.49 41.12 48.82 41.12 72.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "18.8 48.82 41.12 48.82 29.96 60.49 18.8 48.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "41.12 72.16 18.8 72.16 29.96 60.49 41.12 72.16"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "41.12 48.82 52.28 60.49 41.12 72.16 41.12 48.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "63.44 72.16 52.28 60.49 63.44 48.82 63.44 72.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "41.12 48.82 63.44 48.82 52.28 60.49 41.12 48.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "63.44 72.16 41.12 72.16 52.28 60.49 63.44 72.16"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "108.07 72.16 96.91 60.49 108.07 48.82 108.07 72.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "85.75 48.82 96.91 60.49 85.75 72.16 85.75 48.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "108.07 72.16 85.75 72.16 96.91 60.49 108.07 72.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "85.75 48.82 108.07 48.82 96.91 60.49 85.75 48.82"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "63.44 48.82 52.28 37.15 63.44 25.48 63.44 48.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "41.12 25.48 52.28 37.15 41.12 48.82 41.12 25.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "63.44 48.82 41.12 48.82 52.28 37.15 63.44 48.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "41.12 25.48 63.44 25.48 52.28 37.15 41.12 25.48"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "-3.52 25.48 7.64 37.15 -3.52 48.82 -3.52 25.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "18.8 48.82 7.64 37.15 18.8 25.48 18.8 48.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "-3.52 25.48 18.8 25.48 7.64 37.15 -3.52 25.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "18.8 48.82 -3.52 48.82 7.64 37.15 18.8 48.82"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "130.39 48.82 119.23 37.15 130.39 25.48 130.39 48.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "108.07 25.48 119.23 37.15 108.07 48.82 108.07 25.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "130.39 48.82 108.07 48.82 119.23 37.15 130.39 48.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "108.07 25.48 130.39 25.48 119.23 37.15 108.07 25.48"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "152.71 48.82 141.55 37.15 152.71 25.48 152.71 48.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "130.39 25.48 141.55 37.15 130.39 48.82 130.39 25.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "152.71 48.82 130.39 48.82 141.55 37.15 152.71 48.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "130.39 25.48 152.71 25.48 141.55 37.15 130.39 25.48"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "175.03 48.82 163.87 37.15 175.03 25.48 175.03 48.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "152.71 25.48 163.87 37.15 152.71 48.82 152.71 25.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "175.03 48.82 152.71 48.82 163.87 37.15 175.03 48.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "152.71 25.48 175.03 25.48 163.87 37.15 152.71 25.48"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "108.07 48.82 96.91 37.15 108.07 25.48 108.07 48.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "85.75 25.48 96.91 37.15 85.75 48.82 85.75 25.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "108.07 48.82 85.75 48.82 96.91 37.15 108.07 48.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "85.75 25.48 108.07 25.48 96.91 37.15 85.75 25.48"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "85.75 48.82 74.59 37.15 85.75 25.48 85.75 48.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "63.44 25.48 74.59 37.15 63.44 48.82 63.44 25.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "85.75 48.82 63.44 48.82 74.59 37.15 85.75 48.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "63.44 25.48 85.75 25.48 74.59 37.15 63.44 25.48"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "18.8 25.48 29.96 37.15 18.8 48.82 18.8 25.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "41.12 48.82 29.96 37.15 41.12 25.48 41.12 48.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "18.8 25.48 41.12 25.48 29.96 37.15 18.8 25.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "41.12 48.82 18.8 48.82 29.96 37.15 41.12 48.82"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "175.03 165.52 163.87 153.85 175.03 142.18 175.03 165.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "152.71 142.18 163.87 153.85 152.71 165.52 152.71 142.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "175.03 165.52 152.71 165.52 163.87 153.85 175.03 165.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "152.71 142.18 175.03 142.18 163.87 153.85 152.71 142.18"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "152.71 165.52 141.55 153.85 152.71 142.18 152.71 165.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "130.39 142.18 141.55 153.85 130.39 165.52 130.39 142.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "152.71 165.52 130.39 165.52 141.55 153.85 152.71 165.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "130.39 142.18 152.71 142.18 141.55 153.85 130.39 142.18"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "63.44 142.18 74.59 153.85 63.44 165.52 63.44 142.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "85.75 165.52 74.59 153.85 85.75 142.18 85.75 165.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "63.44 142.18 85.75 142.18 74.59 153.85 63.44 142.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "85.75 165.52 63.44 165.52 74.59 153.85 85.75 165.52"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "130.39 165.52 119.23 153.85 130.39 142.18 130.39 165.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "108.07 142.18 119.23 153.85 108.07 165.52 108.07 142.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "130.39 165.52 108.07 165.52 119.23 153.85 130.39 165.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "108.07 142.18 130.39 142.18 119.23 153.85 108.07 142.18"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "-3.52 142.18 7.64 153.85 -3.52 165.52 -3.52 142.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "18.8 165.52 7.64 153.85 18.8 142.18 18.8 165.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "-3.52 142.18 18.8 142.18 7.64 153.85 -3.52 142.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "18.8 165.52 -3.52 165.52 7.64 153.85 18.8 165.52"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "18.8 142.18 29.96 153.85 18.8 165.52 18.8 142.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "41.12 165.52 29.96 153.85 41.12 142.18 41.12 165.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "18.8 142.18 41.12 142.18 29.96 153.85 18.8 142.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "41.12 165.52 18.8 165.52 29.96 153.85 41.12 165.52"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "41.12 142.18 52.28 153.85 41.12 165.52 41.12 142.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "63.44 165.52 52.28 153.85 63.44 142.18 63.44 165.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "41.12 142.18 63.44 142.18 52.28 153.85 41.12 142.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "63.44 165.52 41.12 165.52 52.28 153.85 63.44 165.52"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "108.07 165.52 96.91 153.85 108.07 142.18 108.07 165.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "85.75 142.18 96.91 153.85 85.75 165.52 85.75 142.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "108.07 165.52 85.75 165.52 96.91 153.85 108.07 165.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "85.75 142.18 108.07 142.18 96.91 153.85 85.75 142.18"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "63.44 142.18 52.28 130.51 63.44 118.84 63.44 142.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "41.12 118.84 52.28 130.51 41.12 142.18 41.12 118.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "63.44 142.18 41.12 142.18 52.28 130.51 63.44 142.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "41.12 118.84 63.44 118.84 52.28 130.51 41.12 118.84"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "-3.52 118.84 7.64 130.51 -3.52 142.18 -3.52 118.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "18.8 142.18 7.64 130.51 18.8 118.84 18.8 142.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "-3.52 118.84 18.8 118.84 7.64 130.51 -3.52 118.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "18.8 142.18 -3.52 142.18 7.64 130.51 18.8 142.18"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "130.39 142.18 119.23 130.51 130.39 118.84 130.39 142.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "108.07 118.84 119.23 130.51 108.07 142.18 108.07 118.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "130.39 142.18 108.07 142.18 119.23 130.51 130.39 142.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "108.07 118.84 130.39 118.84 119.23 130.51 108.07 118.84"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "152.71 142.18 141.55 130.51 152.71 118.84 152.71 142.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "130.39 118.84 141.55 130.51 130.39 142.18 130.39 118.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "152.71 142.18 130.39 142.18 141.55 130.51 152.71 142.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "130.39 118.84 152.71 118.84 141.55 130.51 130.39 118.84"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "175.03 142.18 163.87 130.51 175.03 118.84 175.03 142.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "152.71 118.84 163.87 130.51 152.71 142.18 152.71 118.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "175.03 142.18 152.71 142.18 163.87 130.51 175.03 142.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "152.71 118.84 175.03 118.84 163.87 130.51 152.71 118.84"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "108.07 142.18 96.91 130.51 108.07 118.84 108.07 142.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "85.75 118.84 96.91 130.51 85.75 142.18 85.75 118.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "108.07 142.18 85.75 142.18 96.91 130.51 108.07 142.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "85.75 118.84 108.07 118.84 96.91 130.51 85.75 118.84"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "85.75 142.18 74.59 130.51 85.75 118.84 85.75 142.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "63.44 118.84 74.59 130.51 63.44 142.18 63.44 118.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "85.75 142.18 63.44 142.18 74.59 130.51 85.75 142.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "63.44 118.84 85.75 118.84 74.59 130.51 63.44 118.84"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "18.8 118.84 29.96 130.51 18.8 142.18 18.8 118.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "41.12 142.18 29.96 130.51 41.12 118.84 41.12 142.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "18.8 118.84 41.12 118.84 29.96 130.51 18.8 118.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "41.12 142.18 18.8 142.18 29.96 130.51 41.12 142.18"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "63.44 95.5 52.28 83.83 63.44 72.16 63.44 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "41.12 72.16 52.28 83.83 41.12 95.5 41.12 72.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "63.44 95.5 41.12 95.5 52.28 83.83 63.44 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "41.12 72.16 63.44 72.16 52.28 83.83 41.12 72.16"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "-3.52 72.16 7.64 83.83 -3.52 95.5 -3.52 72.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "18.8 95.5 7.64 83.83 18.8 72.16 18.8 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "-3.52 72.16 18.8 72.16 7.64 83.83 -3.52 72.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "18.8 95.5 -3.52 95.5 7.64 83.83 18.8 95.5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "130.39 95.5 119.23 83.83 130.39 72.16 130.39 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "108.07 72.16 119.23 83.83 108.07 95.5 108.07 72.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "130.39 95.5 108.07 95.5 119.23 83.83 130.39 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "108.07 72.16 130.39 72.16 119.23 83.83 108.07 72.16"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "152.71 95.5 141.55 83.83 152.71 72.16 152.71 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "130.39 72.16 141.55 83.83 130.39 95.5 130.39 72.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "152.71 95.5 130.39 95.5 141.55 83.83 152.71 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "130.39 72.16 152.71 72.16 141.55 83.83 130.39 72.16"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "175.03 95.5 163.87 83.83 175.03 72.16 175.03 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "152.71 72.16 163.87 83.83 152.71 95.5 152.71 72.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "175.03 95.5 152.71 95.5 163.87 83.83 175.03 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "152.71 72.16 175.03 72.16 163.87 83.83 152.71 72.16"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "108.07 95.5 96.91 83.83 108.07 72.16 108.07 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "85.75 72.16 96.91 83.83 85.75 95.5 85.75 72.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "108.07 95.5 85.75 95.5 96.91 83.83 108.07 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "85.75 72.16 108.07 72.16 96.91 83.83 85.75 72.16"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "85.75 95.5 74.59 83.83 85.75 72.16 85.75 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "63.44 72.16 74.59 83.83 63.44 95.5 63.44 72.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "85.75 95.5 63.44 95.5 74.59 83.83 85.75 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "63.44 72.16 85.75 72.16 74.59 83.83 63.44 72.16"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "18.8 72.16 29.96 83.83 18.8 95.5 18.8 72.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "41.12 95.5 29.96 83.83 41.12 72.16 41.12 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "18.8 72.16 41.12 72.16 29.96 83.83 18.8 72.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "41.12 95.5 18.8 95.5 29.96 83.83 41.12 95.5"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "175.03 118.84 163.87 107.17 175.03 95.5 175.03 118.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "152.71 95.5 163.87 107.17 152.71 118.84 152.71 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "175.03 118.84 152.71 118.84 163.87 107.17 175.03 118.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "152.71 95.5 175.03 95.5 163.87 107.17 152.71 95.5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "152.71 118.84 141.55 107.17 152.71 95.5 152.71 118.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "130.39 95.5 141.55 107.17 130.39 118.84 130.39 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "152.71 118.84 130.39 118.84 141.55 107.17 152.71 118.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "130.39 95.5 152.71 95.5 141.55 107.17 130.39 95.5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "63.44 95.5 74.59 107.17 63.44 118.84 63.44 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "85.75 118.84 74.59 107.17 85.75 95.5 85.75 118.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "63.44 95.5 85.75 95.5 74.59 107.17 63.44 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "85.75 118.84 63.44 118.84 74.59 107.17 85.75 118.84"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "130.39 118.84 119.23 107.17 130.39 95.5 130.39 118.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "108.07 95.5 119.23 107.17 108.07 118.84 108.07 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "130.39 118.84 108.07 118.84 119.23 107.17 130.39 118.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "108.07 95.5 130.39 95.5 119.23 107.17 108.07 95.5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "-3.52 95.5 7.64 107.17 -3.52 118.84 -3.52 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "18.8 118.84 7.64 107.17 18.8 95.5 18.8 118.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "-3.52 95.5 18.8 95.5 7.64 107.17 -3.52 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "18.8 118.84 -3.52 118.84 7.64 107.17 18.8 118.84"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "18.8 95.5 29.96 107.17 18.8 118.84 18.8 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "41.12 118.84 29.96 107.17 41.12 95.5 41.12 118.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "18.8 95.5 41.12 95.5 29.96 107.17 18.8 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "41.12 118.84 18.8 118.84 29.96 107.17 41.12 118.84"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "41.12 95.5 52.28 107.17 41.12 118.84 41.12 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "63.44 118.84 52.28 107.17 63.44 95.5 63.44 118.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "41.12 95.5 63.44 95.5 52.28 107.17 41.12 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "63.44 118.84 41.12 118.84 52.28 107.17 63.44 118.84"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "108.07 118.84 96.91 107.17 108.07 95.5 108.07 118.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "85.75 95.5 96.91 107.17 85.75 118.84 85.75 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "108.07 118.84 85.75 118.84 96.91 107.17 108.07 118.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "85.75 95.5 108.07 95.5 96.91 107.17 85.75 95.5"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "197.39 188.9 186.24 200.58 175.09 188.9 197.39 188.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "175.09 212.25 175.09 188.9 186.24 200.58 175.09 212.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "197.39 188.9 197.39 212.25 186.24 200.58 197.39 188.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "175.09 188.9 186.24 177.23 197.39 188.9 175.09 188.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "197.39 165.55 186.24 177.23 175.09 165.55 197.39 165.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "175.09 188.9 175.09 165.55 186.24 177.23 175.09 188.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "197.39 165.55 197.39 188.9 186.24 177.23 197.39 165.55"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "197.39 95.5 186.24 107.18 175.09 95.5 197.39 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "175.09 118.85 186.24 107.18 197.39 118.85 175.09 118.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "197.39 95.5 197.39 118.85 186.24 107.18 197.39 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "175.09 118.85 175.09 95.5 186.24 107.18 175.09 118.85"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "175.09 165.55 186.24 153.88 197.39 165.55 175.09 165.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "197.39 142.2 186.24 153.88 175.09 142.2 197.39 142.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "175.09 165.55 175.09 142.2 186.24 153.88 175.09 165.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "197.39 142.2 197.39 165.55 186.24 153.88 197.39 142.2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "197.39 25.45 186.24 37.12 175.09 25.45 197.39 25.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "175.09 48.8 186.24 37.12 197.39 48.8 175.09 48.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "197.39 25.45 197.39 48.8 186.24 37.12 197.39 25.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "175.09 48.8 175.09 25.45 186.24 37.12 175.09 48.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "197.39 2.1 186.24 13.77 175.09 2.1 197.39 2.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "175.09 25.45 186.24 13.77 197.39 25.45 175.09 25.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "197.39 2.1 197.39 25.45 186.24 13.77 197.39 2.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "175.09 25.45 175.09 2.1 186.24 13.77 175.09 25.45"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "175.09 2.1 186.24 -9.58 197.39 2.1 175.09 2.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "197.39 -21.25 197.39 2.1 186.24 -9.58 197.39 -21.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "175.09 2.1 175.09 -21.25 186.24 -9.58 175.09 2.1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "197.39 48.8 186.24 60.47 175.09 48.8 197.39 48.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "175.09 72.15 186.24 60.47 197.39 72.15 175.09 72.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "197.39 48.8 197.39 72.15 186.24 60.47 197.39 48.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "175.09 72.15 175.09 48.8 186.24 60.47 175.09 72.15"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "197.39 72.15 186.24 83.82 175.09 72.15 197.39 72.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "175.09 95.5 186.24 83.82 197.39 95.5 175.09 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "197.39 72.15 197.39 95.5 186.24 83.82 197.39 72.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "175.09 95.5 175.09 72.15 186.24 83.82 175.09 95.5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "175.09 142.2 186.24 130.53 197.39 142.2 175.09 142.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "197.39 118.85 186.24 130.53 175.09 118.85 197.39 118.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "175.09 142.2 175.09 118.85 186.24 130.53 175.09 142.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "197.39 118.85 197.39 142.2 186.24 130.53 197.39 118.85"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "197.39 2.1 208.55 -9.58 219.7 2.1 197.39 2.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "219.7 -21.25 219.7 2.1 208.55 -9.58 219.7 -21.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "197.39 2.1 197.39 -21.25 208.55 -9.58 197.39 2.1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "219.7 2.1 208.55 13.77 197.39 2.1 219.7 2.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "197.39 25.45 208.55 13.77 219.7 25.45 197.39 25.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "219.7 2.1 219.7 25.45 208.55 13.77 219.7 2.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "197.39 25.45 197.39 2.1 208.55 13.77 197.39 25.45"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "197.39 95.5 208.55 83.82 219.7 95.5 197.39 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "219.7 72.15 208.55 83.82 197.39 72.15 219.7 72.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "197.39 95.5 197.39 72.15 208.55 83.82 197.39 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "219.7 72.15 219.7 95.5 208.55 83.82 219.7 72.15"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "219.7 25.45 208.55 37.12 197.39 25.45 219.7 25.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "197.39 48.8 208.55 37.12 219.7 48.8 197.39 48.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "219.7 25.45 219.7 48.8 208.55 37.12 219.7 25.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "197.39 48.8 197.39 25.45 208.55 37.12 197.39 48.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "197.39 165.55 208.55 153.88 219.7 165.55 197.39 165.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "219.7 142.2 208.55 153.88 197.39 142.2 219.7 142.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "197.39 165.55 197.39 142.2 208.55 153.88 197.39 165.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "219.7 142.2 219.7 165.55 208.55 153.88 219.7 142.2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "197.39 188.9 208.55 177.23 219.7 188.9 197.39 188.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "219.7 165.55 208.55 177.23 197.39 165.55 219.7 165.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "197.39 188.9 197.39 165.55 208.55 177.23 197.39 188.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "219.7 165.55 219.7 188.9 208.55 177.23 219.7 165.55"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "219.7 188.9 208.55 200.58 197.39 188.9 219.7 188.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "197.39 212.25 197.39 188.9 208.55 200.58 197.39 212.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "219.7 188.9 219.7 212.25 208.55 200.58 219.7 188.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "197.39 142.2 208.55 130.53 219.7 142.2 197.39 142.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "219.7 118.85 208.55 130.53 197.39 118.85 219.7 118.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "197.39 142.2 197.39 118.85 208.55 130.53 197.39 142.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "219.7 118.85 219.7 142.2 208.55 130.53 219.7 118.85"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "197.39 118.85 208.55 107.18 219.7 118.85 197.39 118.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "219.7 95.5 208.55 107.18 197.39 95.5 219.7 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "197.39 118.85 197.39 95.5 208.55 107.18 197.39 118.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "219.7 95.5 219.7 118.85 208.55 107.18 219.7 95.5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "219.7 48.8 208.55 60.47 197.39 48.8 219.7 48.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "197.39 72.15 208.55 60.47 219.7 72.15 197.39 72.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "219.7 48.8 219.7 72.15 208.55 60.47 219.7 48.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "197.39 72.15 197.39 48.8 208.55 60.47 197.39 72.15"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "331.24 188.9 320.08 200.58 308.93 188.9 331.24 188.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "308.93 212.25 308.93 188.9 320.08 200.58 308.93 212.25"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "308.93 188.9 320.08 177.23 331.24 188.9 308.93 188.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "331.24 165.55 320.08 177.23 308.93 165.55 331.24 165.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "308.93 188.9 308.93 165.55 320.08 177.23 308.93 188.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "331.24 95.5 320.08 107.18 308.93 95.5 331.24 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "308.93 118.85 320.08 107.18 331.24 118.85 308.93 118.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "308.93 118.85 308.93 95.5 320.08 107.18 308.93 118.85"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "308.93 165.55 320.08 153.88 331.24 165.55 308.93 165.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "331.24 142.2 320.08 153.88 308.93 142.2 331.24 142.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "308.93 165.55 308.93 142.2 320.08 153.88 308.93 165.55"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "331.24 25.45 320.08 37.12 308.93 25.45 331.24 25.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "308.93 48.8 320.08 37.12 331.24 48.8 308.93 48.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "308.93 48.8 308.93 25.45 320.08 37.12 308.93 48.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "331.24 2.1 320.08 13.77 308.93 2.1 331.24 2.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "308.93 25.45 320.08 13.77 331.24 25.45 308.93 25.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "308.93 25.45 308.93 2.1 320.08 13.77 308.93 25.45"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "308.93 2.1 320.08 -9.58 331.24 2.1 308.93 2.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "308.93 2.1 308.93 -21.25 320.08 -9.58 308.93 2.1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "331.24 48.8 320.08 60.47 308.93 48.8 331.24 48.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "308.93 72.15 320.08 60.47 331.24 72.15 308.93 72.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "308.93 72.15 308.93 48.8 320.08 60.47 308.93 72.15"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "331.24 72.15 320.08 83.82 308.93 72.15 331.24 72.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "308.93 95.5 320.08 83.82 331.24 95.5 308.93 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "308.93 95.5 308.93 72.15 320.08 83.82 308.93 95.5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "308.93 142.2 320.08 130.53 331.24 142.2 308.93 142.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "331.24 118.85 320.08 130.53 308.93 118.85 331.24 118.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "308.93 142.2 308.93 118.85 320.08 130.53 308.93 142.2"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "242.01 188.9 230.85 200.58 219.7 188.9 242.01 188.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "219.7 212.25 219.7 188.9 230.85 200.58 219.7 212.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "242.01 188.9 242.01 212.25 230.85 200.58 242.01 188.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "219.7 188.9 230.85 177.23 242.01 188.9 219.7 188.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "242.01 165.55 230.85 177.23 219.7 165.55 242.01 165.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "219.7 188.9 219.7 165.55 230.85 177.23 219.7 188.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "242.01 165.55 242.01 188.9 230.85 177.23 242.01 165.55"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "242.01 95.5 230.85 107.18 219.7 95.5 242.01 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "219.7 118.85 230.85 107.18 242.01 118.85 219.7 118.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "242.01 95.5 242.01 118.85 230.85 107.18 242.01 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "219.7 118.85 219.7 95.5 230.85 107.18 219.7 118.85"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "219.7 165.55 230.85 153.88 242.01 165.55 219.7 165.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "242.01 142.2 230.85 153.88 219.7 142.2 242.01 142.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "219.7 165.55 219.7 142.2 230.85 153.88 219.7 165.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "242.01 142.2 242.01 165.55 230.85 153.88 242.01 142.2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "242.01 25.45 230.85 37.12 219.7 25.45 242.01 25.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "219.7 48.8 230.85 37.12 242.01 48.8 219.7 48.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "242.01 25.45 242.01 48.8 230.85 37.12 242.01 25.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "219.7 48.8 219.7 25.45 230.85 37.12 219.7 48.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "242.01 2.1 230.85 13.77 219.7 2.1 242.01 2.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "219.7 25.45 230.85 13.77 242.01 25.45 219.7 25.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "242.01 2.1 242.01 25.45 230.85 13.77 242.01 2.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "219.7 25.45 219.7 2.1 230.85 13.77 219.7 25.45"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "219.7 2.1 230.85 -9.58 242.01 2.1 219.7 2.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "242.01 -21.25 242.01 2.1 230.85 -9.58 242.01 -21.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "219.7 2.1 219.7 -21.25 230.85 -9.58 219.7 2.1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "242.01 48.8 230.85 60.47 219.7 48.8 242.01 48.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "219.7 72.15 230.85 60.47 242.01 72.15 219.7 72.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "242.01 48.8 242.01 72.15 230.85 60.47 242.01 48.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "219.7 72.15 219.7 48.8 230.85 60.47 219.7 72.15"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "242.01 72.15 230.85 83.82 219.7 72.15 242.01 72.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "219.7 95.5 230.85 83.82 242.01 95.5 219.7 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "242.01 72.15 242.01 95.5 230.85 83.82 242.01 72.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "219.7 95.5 219.7 72.15 230.85 83.82 219.7 95.5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "219.7 142.2 230.85 130.53 242.01 142.2 219.7 142.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "242.01 118.85 230.85 130.53 219.7 118.85 242.01 118.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "219.7 142.2 219.7 118.85 230.85 130.53 219.7 142.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "242.01 118.85 242.01 142.2 230.85 130.53 242.01 118.85"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "242.01 2.1 253.16 -9.58 264.32 2.1 242.01 2.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "264.32 -21.25 264.32 2.1 253.16 -9.58 264.32 -21.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "242.01 2.1 242.01 -21.25 253.16 -9.58 242.01 2.1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "264.32 2.1 253.16 13.77 242.01 2.1 264.32 2.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "242.01 25.45 253.16 13.77 264.32 25.45 242.01 25.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "264.32 2.1 264.32 25.45 253.16 13.77 264.32 2.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "242.01 25.45 242.01 2.1 253.16 13.77 242.01 25.45"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "242.01 95.5 253.16 83.82 264.32 95.5 242.01 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "264.32 72.15 253.16 83.82 242.01 72.15 264.32 72.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "242.01 95.5 242.01 72.15 253.16 83.82 242.01 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "264.32 72.15 264.32 95.5 253.16 83.82 264.32 72.15"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "264.32 25.45 253.16 37.12 242.01 25.45 264.32 25.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "242.01 48.8 253.16 37.12 264.32 48.8 242.01 48.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "264.32 25.45 264.32 48.8 253.16 37.12 264.32 25.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "242.01 48.8 242.01 25.45 253.16 37.12 242.01 48.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "242.01 165.55 253.16 153.88 264.32 165.55 242.01 165.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "264.32 142.2 253.16 153.88 242.01 142.2 264.32 142.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "242.01 165.55 242.01 142.2 253.16 153.88 242.01 165.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "264.32 142.2 264.32 165.55 253.16 153.88 264.32 142.2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "242.01 188.9 253.16 177.23 264.32 188.9 242.01 188.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "264.32 165.55 253.16 177.23 242.01 165.55 264.32 165.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "242.01 188.9 242.01 165.55 253.16 177.23 242.01 188.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "264.32 165.55 264.32 188.9 253.16 177.23 264.32 165.55"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "264.32 188.9 253.16 200.58 242.01 188.9 264.32 188.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "242.01 212.25 242.01 188.9 253.16 200.58 242.01 212.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "264.32 188.9 264.32 212.25 253.16 200.58 264.32 188.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "242.01 142.2 253.16 130.53 264.32 142.2 242.01 142.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "264.32 118.85 253.16 130.53 242.01 118.85 264.32 118.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "242.01 142.2 242.01 118.85 253.16 130.53 242.01 142.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "264.32 118.85 264.32 142.2 253.16 130.53 264.32 118.85"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "242.01 118.85 253.16 107.18 264.32 118.85 242.01 118.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "264.32 95.5 253.16 107.18 242.01 95.5 264.32 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "242.01 118.85 242.01 95.5 253.16 107.18 242.01 118.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "264.32 95.5 264.32 118.85 253.16 107.18 264.32 95.5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "264.32 48.8 253.16 60.47 242.01 48.8 264.32 48.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "242.01 72.15 253.16 60.47 264.32 72.15 242.01 72.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "264.32 48.8 264.32 72.15 253.16 60.47 264.32 48.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "242.01 72.15 242.01 48.8 253.16 60.47 242.01 72.15"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "286.62 2.1 297.78 -9.58 308.93 2.1 286.62 2.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "308.93 -21.25 308.93 2.1 297.78 -9.58 308.93 -21.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "286.62 2.1 286.62 -21.25 297.78 -9.58 286.62 2.1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "308.93 2.1 297.78 13.77 286.62 2.1 308.93 2.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "286.62 25.45 297.78 13.77 308.93 25.45 286.62 25.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "308.93 2.1 308.93 25.45 297.78 13.77 308.93 2.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "286.62 25.45 286.62 2.1 297.78 13.77 286.62 25.45"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "286.62 95.5 297.78 83.82 308.93 95.5 286.62 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "308.93 72.15 297.78 83.82 286.62 72.15 308.93 72.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "286.62 95.5 286.62 72.15 297.78 83.82 286.62 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "308.93 72.15 308.93 95.5 297.78 83.82 308.93 72.15"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "308.93 25.45 297.78 37.12 286.62 25.45 308.93 25.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "286.62 48.8 297.78 37.12 308.93 48.8 286.62 48.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "308.93 25.45 308.93 48.8 297.78 37.12 308.93 25.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "286.62 48.8 286.62 25.45 297.78 37.12 286.62 48.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "286.62 165.55 297.78 153.88 308.93 165.55 286.62 165.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "308.93 142.2 297.78 153.88 286.62 142.2 308.93 142.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "286.62 165.55 286.62 142.2 297.78 153.88 286.62 165.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "308.93 142.2 308.93 165.55 297.78 153.88 308.93 142.2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "286.62 188.9 297.78 177.23 308.93 188.9 286.62 188.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "308.93 165.55 297.78 177.23 286.62 165.55 308.93 165.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "286.62 188.9 286.62 165.55 297.78 177.23 286.62 188.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "308.93 165.55 308.93 188.9 297.78 177.23 308.93 165.55"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "308.93 188.9 297.78 200.58 286.62 188.9 308.93 188.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "286.62 212.25 286.62 188.9 297.78 200.58 286.62 212.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "308.93 188.9 308.93 212.25 297.78 200.58 308.93 188.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "286.62 142.2 297.78 130.53 308.93 142.2 286.62 142.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "308.93 118.85 297.78 130.53 286.62 118.85 308.93 118.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "286.62 142.2 286.62 118.85 297.78 130.53 286.62 142.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "308.93 118.85 308.93 142.2 297.78 130.53 308.93 118.85"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "286.62 118.85 297.78 107.18 308.93 118.85 286.62 118.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "308.93 95.5 297.78 107.18 286.62 95.5 308.93 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "286.62 118.85 286.62 95.5 297.78 107.18 286.62 118.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "308.93 95.5 308.93 118.85 297.78 107.18 308.93 95.5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "308.93 48.8 297.78 60.47 286.62 48.8 308.93 48.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "286.62 72.15 297.78 60.47 308.93 72.15 286.62 72.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "308.93 48.8 308.93 72.15 297.78 60.47 308.93 48.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "286.62 72.15 286.62 48.8 297.78 60.47 286.62 72.15"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "286.62 188.9 275.47 200.58 264.32 188.9 286.62 188.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "264.32 212.25 264.32 188.9 275.47 200.58 264.32 212.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "286.62 188.9 286.62 212.25 275.47 200.58 286.62 188.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "264.32 188.9 275.47 177.23 286.62 188.9 264.32 188.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "286.62 165.55 275.47 177.23 264.32 165.55 286.62 165.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "264.32 188.9 264.32 165.55 275.47 177.23 264.32 188.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "286.62 165.55 286.62 188.9 275.47 177.23 286.62 165.55"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "286.62 95.5 275.47 107.18 264.32 95.5 286.62 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "264.32 118.85 275.47 107.18 286.62 118.85 264.32 118.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "286.62 95.5 286.62 118.85 275.47 107.18 286.62 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "264.32 118.85 264.32 95.5 275.47 107.18 264.32 118.85"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "264.32 165.55 275.47 153.88 286.62 165.55 264.32 165.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "286.62 142.2 275.47 153.88 264.32 142.2 286.62 142.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "264.32 165.55 264.32 142.2 275.47 153.88 264.32 165.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "286.62 142.2 286.62 165.55 275.47 153.88 286.62 142.2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "286.62 25.45 275.47 37.12 264.32 25.45 286.62 25.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "264.32 48.8 275.47 37.12 286.62 48.8 264.32 48.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "286.62 25.45 286.62 48.8 275.47 37.12 286.62 25.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "264.32 48.8 264.32 25.45 275.47 37.12 264.32 48.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "286.62 2.1 275.47 13.77 264.32 2.1 286.62 2.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "264.32 25.45 275.47 13.77 286.62 25.45 264.32 25.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "286.62 2.1 286.62 25.45 275.47 13.77 286.62 2.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "264.32 25.45 264.32 2.1 275.47 13.77 264.32 25.45"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "264.32 2.1 275.47 -9.58 286.62 2.1 264.32 2.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "286.62 -21.25 286.62 2.1 275.47 -9.58 286.62 -21.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "264.32 2.1 264.32 -21.25 275.47 -9.58 264.32 2.1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "286.62 48.8 275.47 60.47 264.32 48.8 286.62 48.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "264.32 72.15 275.47 60.47 286.62 72.15 264.32 72.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "286.62 48.8 286.62 72.15 275.47 60.47 286.62 48.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "264.32 72.15 264.32 48.8 275.47 60.47 264.32 72.15"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "286.62 72.15 275.47 83.82 264.32 72.15 286.62 72.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "264.32 95.5 275.47 83.82 286.62 95.5 264.32 95.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "286.62 72.15 286.62 95.5 275.47 83.82 286.62 72.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "264.32 95.5 264.32 72.15 275.47 83.82 264.32 95.5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "264.32 142.2 275.47 130.53 286.62 142.2 264.32 142.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "286.62 118.85 275.47 130.53 264.32 118.85 286.62 118.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "264.32 142.2 264.32 118.85 275.47 130.53 264.32 142.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "286.62 118.85 286.62 142.2 275.47 130.53 286.62 118.85"
  }))))), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m312.71-16.29H7C-1.36-16.29-8.14-9.2-8.14-.45v187.99c0,8.75,6.78,15.84,15.14,15.84h305.71c8.36,0,15.14-7.09,15.14-15.84V-.45c0-8.75-6.78-15.84-15.14-15.84Z"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextura);
export default __webpack_public_path__ + "static/media/textura.a3dbe597eb2ad98575848638631b13f6.svg";
export { ForwardRef as ReactComponent };